import { gql } from '@apollo/client'

export default gql`
  fragment LibraryGuideCardComponent on LibraryGuide {
    id
    slug
    title
    image {
      url
      blurhash
    }
  }
`
